import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/useUserStore";
import { isLocal } from "@faire/web--source/common/user-agent/isLocal";
import { Button } from "@faire/web--source/slate/Button";
import { Modal } from "@faire/web--source/slate/deprecated/Modal";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled from "styled-components";

interface IProps {
  onClose: () => void;
  signup: boolean;
}

export const LoggedInAdminWarningModal: React.FC<IProps> = ({
  onClose,
  signup,
}) => {
  const { emailAddress, logOut } = useUserStore(["emailAddress", "logOut"]);

  const adminLink = isLocal()
    ? "http://localhost:3003/admin2"
    : "https://www.faire-stage.com/admin2";

  return (
    <Modal justify="center" onClose={onClose}>
      <Column align="center">
        {signup ? (
          <Typography variant="displaySSansRegular" align="center">
            Warning: sign up process will fail
          </Typography>
        ) : null}
        <Spacer height="2x" />
        <Typography variant="paragraphSansRegular" align="center">
          You are currently logged in as {emailAddress} on faire-stage.com.
        </Typography>
        {signup ? (
          <Typography variant="paragraphSansRegular" align="center">
            To successfully go through the sign up flow, you must log out.
          </Typography>
        ) : null}
        <Spacer height="3x" />
        <StyledButton variant="primary" onClick={() => logOut()}>
          Log me out
        </StyledButton>
        <Spacer height="2x" />
        <Button variant="tertiary" linkTo={adminLink}>
          Take me to Admin Portal
        </Button>
      </Column>
    </Modal>
  );
};

const StyledButton = styled(Button)`
  width: 100%;
`;
